import React, { createContext, useEffect, useState } from "react";
import axios from 'axios'
import { ToastContainer, toast, Flip, Zoom } from 'react-toastify';
// Import Toastify CSS for styling
import 'react-toastify/dist/ReactToastify.css';
// import {Modal, ModalHeader, ModalBody, ModalFooter, Button} from 'reactstrap'
import Acknowledgement from "../Alerts/Acknowledgement";
// import { setRef } from "@mui/material";
// import { useLocation, useNavigate } from 'react-router-dom'

// Create the context
export const StockContext = createContext(null);

//Create the Provider component
export const StockProvider = ({ children }) => {
    const [stocksDF, setStocksDF] = useState(null)
    // const [MinimumPrice, setMinimumPrice] = useState([])
    const [NegativePriceStocks, setNegativePriceStocks] = useState([])
    const [PositivePriceStocks, setPositivePriceStocks] = useState([])
    const [StockGraphList, setStockGraphList] = useState([])
    const [loading, setLoading] = useState(false)
    const [loading_stock_df, setLoading_stock_df] = useState(false)
    const [stockLists, SetStockLists] = useState([])
    const [addedStocks, setAddedStocks] = useState([])
    const [trigger, setTrigger] = useState(false)
    const [paid, setPaid] = useState(null)
    const [alert_message, setAlert_message] = useState(null)
    const [message_status, setMessage_status] = useState(null)
    const [referral_code, setReferral_code] = useState(null)
    const [referral_code_input, setReferral_code_input] = useState(null)
    const [user_referral_code, setUser_referral_code] = useState(null)
    // const [todayStock, setTodayStock] = useState(null)
    const [bootstrap_modal_open, setBootstrap_modal_open] = useState(false)

    //Get User email ID
    const [user, setUser] = useState(null)
    // const [username, setUsername] = useState(null)

    // if (user) {console.log(user.signInDetails.loginId);console.log(username)}

    // Fetch stock list data from the SQL server backend API
    const FetchStockList = () =>  {axios.post('https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/nse_stock_list/stockLists'
        , {
            headers: {"Content-Type":'application/json'}
        }
    )
            .then(response => {
                if (response.status === 200) {
                    SetStockLists(response.data); // Set data only if the status is 200 (OK)
                } else {
                    console.error('Unexpected status code:', response.status); // Handle other status codes
                }
            })
            .catch(error => {
                if (error.response) {
                    // The request was made, and the server responded with a status code outside of the 2xx range
                    console.error(`Error: ${error.response.data.message} (Status: ${error.response.status})`);
                } else if (error.request) {
                    // The request was made, but no response was received
                    console.error('No response received:', error.request);
                } else {
                    // Something else happened in setting up the request
                    console.error('Error in setup:', error.message);
                }
            });}
    // console.log(stockLists)

    // To fetch wallet amount.
    const fetch_wallet_data = async () => {
        setLoading(true)
    try{
        const res = await axios.post('https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/payments/update_wallet'
            , {email: user.signInDetails.loginId}
            , { 
                headers: {"Content-Type":'application/json'}
             }
        );
        setPaid(res.data.wallet_balance)
        } catch(error){console.error("There was an error getting wallet balance", error)}
        finally {setLoading(false)}
    } 


    //Related to FilterStock.jsx
    const fetchAddedStocks = async () => {
        try{
            const response = await axios.post("https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/user/addedStocks"
                , {email: user.signInDetails.loginId}
                , {
                    headers: {"Content-Type":'application/json'}
                }
            )
            setAddedStocks(response.data)
        } catch(error) {console.error('There was an error fetching the stock count:', error);}

        try{
            const response = await axios.post("https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/user/user_temp_data"
                , {email: user.signInDetails.loginId}
                , {
                    headers: {"Content-Type":'application/json'}
                }
            )
            setStocksDF(response.data.df_today)
        } catch(error) {console.error('There was an error fetching the stock count:', error);}

        
    } 

    console.log(stocksDF)
    // Creating the user in the database:
    const user_exists_or_create = async () => {
        if (user!==null){
            try{
                const response = await axios.post('https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/user/user_creation'
                    , {email: user.signInDetails.loginId},
                    {headers: {
                            'Content-Type': 'application/json'  // Set the content type to application/json
                        }});
                if (response.status === 200 || 201) { setReferral_code(response.data.message);
                                    setUser_referral_code(response.data.existing_referral_code)}
            } catch(error) {console.error('There was an error fetching the stock count:', error);}}}

            // console.log(referral_code)

            useEffect(() => {
                const user_stock_list_wallet = async () => {
                    if(user!==null){
                        try {
                            // Wait for user creation or existence check
                            await user_exists_or_create();
                            // Wait for stock list fetch
                            await FetchStockList();
                            // Wait for wallet data fetch
                            await fetch_wallet_data();
                        } catch (error) {
                            console.error('Error inn executing functions:', error)
                        }
                    }
                }
                user_stock_list_wallet()
            }, [user] )


        useEffect(()=>{
            if(user!==null){
            //Related to FilterStock.jsx
            fetchAddedStocks();
            }
        },[trigger, user])


// useEffect( ()=>{
//     if( alert_message != null ){
//         alert(alert_message)
//     }
// },[alert_message] )

useEffect(() => {
    if (alert_message != null) {
        if(message_status === 'default' ) {
            toast(alert_message, {
            position: "top-center",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: false,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
            transition: Flip,
        })};
        if(message_status === 'error' ) {
            toast.error(alert_message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
                });
        };
        if(message_status === 'warning' ) {
            toast.warn(alert_message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "colored",
                transition: Flip,
                });
        };
        if(message_status === 'success' ) {
            toast.success(alert_message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Flip,
                });
        };
        if(message_status === 'info') {
            toast.info(alert_message, {
                position: "top-center",
                autoClose: 5000,
                hideProgressBar: false,
                closeOnClick: false,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
                theme: "light",
                transition: Zoom,
                });
        }
        
        setAlert_message(null); // Reset alert_message after showing the toast
        setMessage_status(null); // Reset alert_message after showing the toast
    }
}, [alert_message]);

    

    const handleDeleteItem_filter_func = async ({ itemSymbol }) => {
        try {
            const response = await axios.post("https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/user/deleteRecord"
                , { itemSymbol, email: user.signInDetails.loginId }
                , {
                    headers: {"Content-Type":'application/json'}
                }
            );
            if (response.status === 200) { console.log("Item removed from database:", response.data.message); setTrigger(!trigger) }
            else if (response.status === 404) { console.error("Record not found:", response.data.message); }
        } catch (error) {
            if (error.response) {
                if (error.response.status === 400) { console.error("Bad request:", error.response.data.message); }
                else if (error.response.status === 404) { console.error("Record not found:", error.response.data.message); }
                else if (error.response.status === 500) { console.error("Server error during deletion:", error.response.data.message); }
                else { console.error("Unexpected error:", error.response.data.message); }
            } else {
                console.error("Error making request:", error.message);
            }
        }
    }

    const handleAddItem_filter_func = async ([ItemSubset]) => {
        try {
            const response = await axios.post("https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/user/add"
                , {ItemSubset, email: user.signInDetails.loginId}
                , {
                    headers: {"Content-Type":'application/json'}
                }
            );
            if (response.status === 201) {
                console.log("Item added to database:", response.data.message); // On success 
                setTrigger(!trigger)
            }
        } catch (error) {
            if (error.response) {
                // Handle known status codes
                if (error.response.status === 400) { console.error("Invalid input data:", error.response.data.message); }
                else if (error.response.status === 409) { console.error("Duplicate stock symbol:", error.response.data.message); }
                else if (error.response.status === 500) { console.error("Server error during insertion:", error.response.data.message); }
                else { console.error("Unexpected error:", error.response.data.message); }
            } else {
                console.error("Error making request:", error.message); // Handle cases where no response is received
            }
        }
    }

    const handleSubmit = async (radioValue, WeekOrMonths) => {
        setNegativePriceStocks(null)
        setPositivePriceStocks(null)
        setStockGraphList(null)
        setLoading(true)
        setAlert_message(null)
        setMessage_status(null)
        try {
            const response = await axios.post("https://yycqvy4xk4.execute-api.ap-south-1.amazonaws.com/Dev/analytics/stock_analysis", { weekNum: radioValue, 
                                                            timePeriod: WeekOrMonths, 
                                                            email: user.signInDetails.loginId});
            setNegativePriceStocks(response.data.NegativePriceStocks);
            setPositivePriceStocks(response.data.PositivePriceStocks);
            setStockGraphList(response.data.List_Stocks_for_graphs);
            setAlert_message(response.data.alert);
            setMessage_status(response.data.message_status);
        }
        catch (error) { console.error("There was an error getting the stock result!", error) }
        finally { if(NegativePriceStocks !== null && PositivePriceStocks !== null && StockGraphList !== null )  setLoading(false) }
    }

    // console.log(NegativePriceStocks)
    // console.log(PositivePriceStocks)
    // console.log(StockGraphList)
    // console.log(message_status)

    const handlePaymentInfo = async (userPayment) => {
        setLoading(true)
        setPaid(null)
        console.log(userPayment)
        try{
            // Make the post request and await response from server
            const response = await axios.post("https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/payments/payment_users", {amount:userPayment, email:user.signInDetails.loginId})

            // Access the response data
            const {message, wallet_balance} = response.data

            setPaid(wallet_balance)
            // console.log(message)
            // console.log(insertedData)
            // console.log(userPayment)
        } 
        catch(error) {console.error("There was an error while updating the payment details", error)}
        finally {setLoading(false)}
    }

    const handleUpdate = async (user) => {
        setLoading_stock_df(true)
        setStocksDF(null)
        setNegativePriceStocks(null)
        setPositivePriceStocks(null)
        setAlert_message(null)
        // console.log(user)
        try {
            await axios.post('https://yycqvy4xk4.execute-api.ap-south-1.amazonaws.com/Dev/analytics/update_stock_data', {email: user.signInDetails.loginId}, 
                {
                    headers: {
                        'Content-Type': 'application/json'  // Set the content type to application/json
                    }
        }).then(res=>{setStocksDF(res.data.df_today); setPaid(res.data.wallet_balance); setAlert_message(res.data.alert); setMessage_status(res.data.message_status) })
            
        } catch(error){console.error("There was an error getting today-stock", error)}
        finally{setLoading_stock_df(false)}
    }
    // console.log(stocksDF)
    // console.log(alert_message)

    //Related to FilterStock.jsx
    const referral_code_handler = async () => {
            try{
                const response = await axios.post("https://8d03jbj0jk.execute-api.ap-south-1.amazonaws.com/Dev/payments/referral_handler"
                    , {email: user.signInDetails.loginId, received_code: referral_code_input}
                    , {headers: {"Content-Type":'application/json'}}
                )
                setAlert_message(response.data.alert)
                setMessage_status(response.data.message_status)
            } catch(error) {console.error('There was an error handling the referral code:', error);}
        } 

    useEffect( ()=>{
        if(
            referral_code == 'User created successfully and kickStart amount added'
            // referral_code == 'Existing user'
        ){const input = prompt('Do you have any referral code? If yes, please paste it below');
            if(input){ setReferral_code_input(input.trim()) }
            }
    },[referral_code] )

    useEffect( () => {            
        if (referral_code_input !== null){
        referral_code_handler(); // Call handler when `referral_code_input` is updated
    }}, [referral_code_input] )

    // console.log(referral_code_input)
    // console.log(alert_message)
    // console.log(message_status)
    // useEffect for Modal - Acknowledgement notification
    useEffect( () => {
        setBootstrap_modal_open(true)
    } , [] )
    const toggle_bootstrap_modal = () => {
        setBootstrap_modal_open(false)
    }


    return (
        <StockContext.Provider value={{
            stocksDF, handleSubmit, loading, loading_stock_df,
            NegativePriceStocks, PositivePriceStocks,
            stockLists, StockGraphList, handleDeleteItem_filter_func, handleAddItem_filter_func, addedStocks,
            handlePaymentInfo, paid, handleUpdate, setUser, user, setAlert_message, setMessage_status, user_referral_code
        }}>
            <ToastContainer />
            {children}

            <Acknowledgement bootstrap_modal_open={bootstrap_modal_open} toggle_bootstrap_modal={toggle_bootstrap_modal}/>

        </StockContext.Provider>
    )
}